import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const getSourceFilters = (state: RootState) => state.sourceFilter;
export const getNoOfActiveSourceFilters = createSelector(
  (state: RootState) => state.sourceFilter,
  (activeSourceFilters) =>
    Object.values(activeSourceFilters).reduce((acc, value) => {
      if (!value) return acc;

      if (typeof value === "boolean" || typeof value === "string") return acc + 1;

      if (Array.isArray(value) && value.length > 0) return acc + 1;

      return acc;
    }, 0),
);
